import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Input,
  Button,
  Box,
  Card,
  useToast,
  Flex,
  Text,
  VStack,
  HStack,
} from "@chakra-ui/react";
import axiosInstance from "../routes/axiosInstance";
import { useAuth } from "../context/AuthContext";
import BackButton from "../components/BackButton";

const VerifyEmailPage = () => {
  const { currentUser, checkUserAuth } = useAuth();
  const [emailOtp, setEmailOtp] = useState("");
  const [submitLoading, setSubmitLoading] = useState(false);
  const [resendLoading, setResendLoading] = useState(false);
  const toast = useToast();
  const navigate = useNavigate();

  const maskEmailId = (email) => {
    const [username, domain] = email.split("@");
    const visibleStart = username.slice(0, 2);
    const visibleEnd = username.slice(-2);
    const maskedUsername =
      visibleStart + "*".repeat(username.length - 4) + visibleEnd;
    const maskedEmail = maskedUsername + "@" + domain;
    return maskedEmail;
  };

  const resendOtpHandler = async () => {
    setResendLoading(true);
    const config = {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${currentUser.token}`,
      },
    };

    try {
      await axiosInstance.post(`/api/users/resend-otp`, {}, config);
      setResendLoading(false);
      toast({
        title: "OTP Sent",
        description: `New OTP has been sent to your email.`,
        status: "success",
        duration: 10000,
        isClosable: true,
      });
    } catch (error) {
      setResendLoading(false);
      checkUserAuth(error.status);
    }
  };

  const submitOtpHandler = async (user) => {
    if (!emailOtp || emailOtp.length !== 6) {
      toast({
        title: "Invalid OTP",
        description: "Please enter a 6-digit OTP.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return false;
    }
    const verifyOtpPayload = {
      otp: emailOtp,
    };

    setSubmitLoading(true);
    const config = {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${currentUser.token}`,
      },
    };

    try {
      const newGroupData = await axiosInstance.post(
        `/api/users/verify-otp`,
        verifyOtpPayload,
        config,
      );
      console.log(newGroupData.data.data);
      setSubmitLoading(false);
      navigate(`/chats`);
    } catch (error) {
      if (error.response?.data?.error) {
        toast({
          title: "Verification Failed",
          description: error.response.data.error,
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      }
      setSubmitLoading(false);
      checkUserAuth(error.status);
    }
  };

  // const handleEnterKeyPress = (event) => {
  //   if (event.key === "Enter") {
  //     submitOtpHandler();
  //   }
  // };

  return (
    <Flex direction="column" h="100vh" maxW="md" mx="auto" p={4}>
      <Card p={4} h="calc(100vh - 32px)">
        <BackButton />
        <Box mt="50px" p="6" boxShadow="md" borderRadius="lg">
          <VStack spacing={4}>
            <Text fontSize="xl" fontWeight="bold">
              Verify your email address
            </Text>
            <Text fontSize="sm" color="gray.500">
              Enter the 6-digit OTP sent to your email
            </Text>
            <Text fontSize="sm" color="gray.500">
              {maskEmailId(currentUser.email)}
            </Text>
            <HStack>
              <Input
                type="number"
                placeholder="Enter OTP"
                value={emailOtp}
                onChange={(e) => setEmailOtp(e.target.value)}
                maxLength={6}
                width="200px"
                textAlign="center"
              />
            </HStack>
            <Button
              colorScheme="teal"
              width="full"
              onClick={() => submitOtpHandler()}
              isLoading={submitLoading}
              isDisabled={emailOtp.length !== 6}
            >
              Verify OTP
            </Button>
            <Text fontSize="sm">
              Didn't receive the OTP?{" "}
              <Button
                variant="link"
                colorScheme="teal"
                isLoading={resendLoading}
                onClick={() => resendOtpHandler()}
              >
                Resend OTP
              </Button>
            </Text>
          </VStack>
        </Box>
      </Card>
    </Flex>
  );
};

export default VerifyEmailPage;
